import { FC } from 'react';
import { ServiceProviderDetailsDto } from 'src/generated/services/TFinancialApi';
import { beautifyEnum } from 'src/utils/utility';
import { formatDate } from 'src/utils/date';
import { CardLanding } from '../../molecules/card/CardLanding';
import { TransportMedium } from '../../molecules/card/types';

interface RateCardProviderCardProps {
  item: ServiceProviderDetailsDto;
}

export const RateCardProviderCard: FC<RateCardProviderCardProps> = ({ item }) => (
  <CardLanding
    title={beautifyEnum(item?.serviceProviderCode)?.toUpperCase()}
    info={`${item?.totalShippingServiceCount || 0} Shipping Services`}
    transportMedium={item?.modality as TransportMedium}
    path={`ratecard-manager?service-provider=${item?.serviceProviderCode}&modality=${item?.modality}`}
  >
    {item?.latestRateCardEndDate && (
      <div className='flex flex-col'>
        <div className='text-10 text-[#808080] font-normal'>Latest Rate Card Validity Period</div>
        <div className='text-12 font-medium mt-2'>
          {formatDate(new Date(item?.latestRateCardStartDate))} to {formatDate(new Date(item?.latestRateCardEndDate))}
        </div>
      </div>
    )}
  </CardLanding>
);
